import PageHeader from "@/components/PageHeader";
import Gallery from "@/components/Gallery";
import CtaBand from "@/components/CtaBand";
import { useSeo } from "@/lib/seo";

export default function GalleryPage() {
  useSeo({
    title: "Photo Gallery | Cool Runnings Cape Town",
    description:
      "Real photos from the track: birthdays, school outings and refuels at Cool Runnings Toboggan Family Park, Cape Town.",
    keywords: "Cool Runnings photos, toboggan park photos Cape Town, family fun photos Cape Town, Cool Runnings gallery",
    image: "/og/gallery.jpg",
  });
  return (
    <>
      <PageHeader
        goodgirlTitle
        pageName="Gallery"
        eyebrow="Photos & videos"
        title="GALLERY"
        subline="Real moments from the track and the party lawn — straight from the park."
        image="/park-launch.jpg"
        mascot={[
          "That's me at the track — say cheese!",
          "Real smiles from real riders!",
          "Every photo here is a good day!",
        ]}
      />
      <Gallery />
      <CtaBand />
    </>
  );
}
